import fetch from "./fetch";
let HEALTHAPI = process.env.VUE_APP_HEALTH_API;
// 获取添加好友申请/话题群聊申请列表-按3天分组
export function getFriendInviteListGroupByDate(params) {
	return fetch({
		url: "/friend/getFriendInviteListGroupByDate",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params,
	});
}
//处理好友/话题群聊邀请
export function processInvite(params) {
	return fetch({
		url: "/friend/processInvite",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params,
	});
}
//保存消息已读时间
export function saveLastOpenChatTime(params) {
	return fetch({
		url: "/groupChat/saveLastOpenChatTime",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "get",
		params
	});
}
//添加好友申请
export function addFriend(params) {
	return fetch({
		url: "/friend/inviteFriend",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params,
	});
}
//查询好友申请/未读消息数量
export function getUnreadCount(params) {
	return fetch({
		url: "/friend/getUnreadCount",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params,
	});
}
//获取好友列表按照首字母分组
export function getFriendListGroup(params) {
	return fetch({
		url: "/friend/getFriendListGroup",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params,
	});
}
//查询群组列表按照首字母分组
export function getGroupListGroup(params) {
	return fetch({
		url: "/groupChat/getGroupListGroup",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params,
	});
}
//查询张女士家庭成员信息 userId1000-1003
export function getBaseUserInfoList(params) {
	return fetch({
		url: "/customer/getBaseUserInfoList",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params,
	});
}